<input #fileInput type="file" accept="image/*" class="d-none" (change)="onFileChange($event)" />
<div class="upload-file-box" (click)="open()" *ngIf="type == 'box'">
</div>
<div class="upload-file-inline" *ngIf="type == 'inline'">
  <ax-text-box label="{{ label }}">
    <ax-button (click)="open()">
      <i class="fas fa-upload"></i>
    </ax-button>
  </ax-text-box>
</div>